import React from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';

export const ProgressStepper = ({
  steps,
  currentStep,
  activeColor = 'blue.500',
  inactiveColor = 'gray.200',
  circleSize = '16px',
  lineHeight = '2px',
}) => {
  return (
    <HStack spacing={0} width="100%" position="relative">
      {steps.map((step, index) => {
        const isPreviousStepOrCurrent =
          step.id < currentStep || currentStep === step.id;
        return (
          <React.Fragment key={step.id}>
            <VStack spacing={3} flex={1}>
              <Text
                fontSize="sm"
                fontWeight={currentStep === step.id ? 'bold' : 'normal'}
                // color={currentStep === step.id ? activeColor : 'gray.500'}
              >
                {step.name}
              </Text>
              <Box width="100%" position="relative">
                <Box
                  w="full"
                  h={lineHeight}
                  bg={isPreviousStepOrCurrent ? activeColor : inactiveColor}
                  position="relative"
                />
                <Box
                  position="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50%, -50%)"
                  w={circleSize}
                  h={circleSize}
                  borderRadius="full"
                  border="2px solid"
                  borderColor={
                    isPreviousStepOrCurrent ? activeColor : inactiveColor
                  }
                  bg={isPreviousStepOrCurrent ? activeColor : 'white'}
                  zIndex={1}
                />
              </Box>
            </VStack>
            {index < steps.length - 1 && (
              <Box
                data-testid="progress-line"
                marginTop={'33px'}
                flex={1}
                h={lineHeight}
                bg={
                  steps[index + 1].id <= currentStep
                    ? activeColor
                    : inactiveColor
                }
              />
            )}
          </React.Fragment>
        );
      })}
    </HStack>
  );
};
